module.exports = __webpack_public_path__ + "static/img/6.cabe039.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/6.png
// module id = Tfo2
// module chunks = 0